<template>
  <div ref="viewer" @touchstart="recordStart" @touchend="recordEnd" class="h-full overflow-auto">
    <updates v-if="view == 'updates'" />
    <info v-if="view == 'info'" />
    <artists v-if="view == 'artists'" />
    <trailer v-if="view == 'trailer'" />
    <visit v-if="view == 'visit'" />
    <press v-if="view == 'press'" />
    <credits v-if="view == 'credits'" />
  </div>
</template>

<script>
const Updates = () =>
  import(/* webpackChunkName: "Updates" */ "@/components/Updates.vue");
const Info = () =>
  import(/* webpackChunkName: "Info" */ "@/components/Info.vue");
const Artists = () =>
  import(/* webpackChunkName: "Artists" */ "@/components/Artists.vue");
const Trailer = () =>
  import(/* webpackChunkName: "Trailer" */ "@/components/Trailer.vue");
const Visit = () =>
  import(/* webpackChunkName: "Visit" */ "@/components/Visit.vue");
const Press = () =>
  import(/* webpackChunkName: "Viewer" */ "@/components/Press.vue");
const Credits = () =>
  import(/* webpackChunkName: "Credits" */ "@/components/Credits.vue");
export default {
  props: {
    view: String,
  },
  components: {
    Updates,
    Info,
    Artists,
    Trailer,
    Visit,
    Press,
    Credits,
  },
  data() {
    return {
      touchstartX: 0,
      touchendX: 0,
    }
  },
  methods: {
    recordStart(event) {
      this.touchstartX = event.changedTouches[0].screenX;
    },
    recordEnd(event) {
      this.touchendX = event.changedTouches[0].screenX;
      this.handleGesture();
    },
    handleGesture() {
      let diff = this.touchendX - this.touchstartX;
      if (this.touchendX > this.touchstartX && diff > 60) {
          this.$root.$emit('goToHome');
      }
    },
    scrollToTop() {
      this.$refs.viewer.scrollTop = 0;
    }
  }
};
</script>
